import jwtDecode from "jwt-decode";

const getRoleIdFromToken = () => {
    const token = localStorage.getItem("access-token");

    if (token) {
        try {
            const decoded = jwtDecode(token);
            return decoded.RoleId ?? decoded.roleId ?? decoded.RoleID ?? decoded.role_id;
        } catch (e) {
            return undefined;
        }
    }
    return undefined;
};

export default getRoleIdFromToken;
